import qs from 'qs';
import {connect} from 'react-redux';
import React, {Component} from 'react';

import Map from '../Base/Map';
import Layout from '../Base/Layout';
import * as SearchConst from '../../constants/Search';
import * as ObjectConst from '../../constants/Property';
import LeftBoxContentBuy from './Buy/LeftBoxContentBuy';
import LeftBoxContentRental from './Rental/LeftBoxContentRental';
import {
    findObjects,
    setMinPrice,
    setMaxPrice,
    setSearchType,
    setHorizontalMode,
    setIsShowAdvancedSearch
} from '../../actions/Search';

const BUY_TYPE = 'buy';
const RENTAL_TYPE = 'rental';

const defaultProps = {
    setSearchType: type => {
    },
    setMinPrice: minPrice => {
    },
    setMaxPrice: maxPrice => {
    },
    findObjects: requestParams => {
    },
    setHorizontalMode: isHorizontalMode => {
    },
    setIsShowAdvancedSearch: isShowAdvancedSearch => {
    }
};

class SearchPage extends Component {
    state = {
        isNeedFirstSearch: true
    };

    componentDidMount() {
        if (this.state.isNeedFirstSearch) {
            this.setSearchType();
        }

        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);
    }

    componentDidUpdate() {
        if (this.state.isNeedFirstSearch) {
            this.setSearchType();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        const {isShowAdvancedSearch, isShowAllFilters, isHorizontalMode} = this.props;

        if (window.innerWidth < 1171) {
            if (isShowAdvancedSearch && !isShowAllFilters) {
                this.props.setIsShowAdvancedSearch(false);
            }

            if (isHorizontalMode) {
                this.props.setHorizontalMode(false);
            }
        }
    };

    setSearchType = () => {
        const {requestParams} = this.props;
        const pageParams = qs.parse(this.props.location.search.substring(1));
        const newRequestParams = Object.assign({}, requestParams);
        let type;

        switch (pageParams.type) {
            case RENTAL_TYPE:
                type = ObjectConst.TYPE.RENT;
                break;
            case BUY_TYPE:
            default:
                type = ObjectConst.TYPE.SELL;
        }
        this.props.setSearchType(type);

        newRequestParams.type = type;
        this.props.findObjects(newRequestParams);

        this.setState({
            isNeedFirstSearch: false
        });
    };

    getSearchLink = () => {
        const {dateStart, dateEnd} = this.props;
        let response = '?';

        if (dateStart !== undefined) {
            response += `${SearchConst.REQUEST_PARAMS_NAMES.DATE_START}=${dateStart}&`;
        }
        if (dateEnd !== undefined) {
            response += `${SearchConst.REQUEST_PARAMS_NAMES.DATE_END}=${dateEnd}`;
        }
        return response;
    };

    render() {
        const {i18n, isGoogleApiInit, defaultLat, isHorizontalMode, requestParams, searchResult} = this.props;

        return (
            <Layout title={i18n['search.document.title'] !== undefined ? i18n['search.document.title'] : ''}>
                {this.props.searchPage.searchType === SearchConst.SEARCH_TYPE.RENTAL ?
                    <LeftBoxContentRental /> :
                    <LeftBoxContentBuy />}

                {isGoogleApiInit && defaultLat && !isHorizontalMode && <Map
                    id="map"
                    zoom={10}
                    className="map_right"
                    objects={searchResult.rows}
                    searchLink={this.getSearchLink()}
                    centerLng={requestParams.centerLng}
                    centerLat={requestParams.centerLat}
                />}
            </Layout>
        )
    }
}

SearchPage.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    searchPage: state.searchPage,
    searchResult: state.searchPage.searchResult,
    requestParams: state.searchPage.requestParams,
    defaultLat: state.configuration.main.defaultLat,
    dateEnd: state.searchPage.requestParams.dateEnd,
    maxPrice: state.searchPage.requestParams.maxPrice,
    isHorizontalMode: state.searchPage.isHorizontalMode,
    dateStart: state.searchPage.requestParams.dateStart,
    isShowAllFilters: state.searchPage.isShowAllFilters,
    isGoogleApiInit: state.configuration.isGoogleApiInit,
    isShowAdvancedSearch: state.searchPage.isShowAdvancedSearch
});

const mapDispatchToProps = {
    findObjects,
    setMinPrice,
    setMaxPrice,
    setSearchType,
    setHorizontalMode,
    setIsShowAdvancedSearch
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);


// WEBPACK FOOTER //
// ./src/components/Search/SearchPage.js